/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

type Props = {
  color: string;
  titleFontSize: string;
  titleLineHeight: string;
  subtitleFontSize: string;
  subtitleLineHeight: string;
  subtitleMarginTop: string;
  blackSubtitleColor: string;
  blackSubtitleFontSize: string;
};

declare global {
  interface EXOComponentStyles {
    insurance_Title?: Partial<Props>;
  }
}

export default (props: EXOThemeProps): Props => {
  return {
    // Default theme

    color: props.theme.colors.link.base,
    titleFontSize: '1rem',
    titleLineHeight: '1.375rem',
    subtitleFontSize: '0.75rem',
    subtitleLineHeight: '1.063rem',
    subtitleMarginTop: '0.313rem',
    blackSubtitleColor: '#473F4A',
    blackSubtitleFontSize: '0.875rem',

    // Override with custom theme
    ...props.theme?.insurance?.insurance_Title,
    ...props.theme?.byComponent?.insurance_Title
  };
};
